import { Link, useRoute, useRouteData } from "@bcm-dev/bcms-vite";
import { UIButton } from "components/ui";
import { SVGAsset } from "res";

import "./styles.css";

export default function ManageAlertsContent(props) {
    const navigate = useRoute();
    const { added = false } = useRouteData().route ?? {};

    const onCurrentAlerts = evt => navigate("/advancedAlerts/currentAlerts");
    const onAddAlert = evt => navigate("/advancedAlerts/addAlert");

    return (
        <div className="manage-alerts-content back-link-padding">
            <Link to="/advancedAlerts" className="back-link">
                <span><SVGAsset id="LeftChevronIcon" /> Back</span>
            </Link>
            
            <p className="page-subtitle">Manage Alerts</p>

            { added &&
                <div className="confirmation-banner flex-container flex-horizontal">
                    <SVGAsset id="CircleCheckmarkIcon" className="set-width icon checkmark-icon" />
                    <div className="flex-width confirm-text">The alert was successfully added.</div>
                </div> }

            <div className="flex-container flex-horizontal button-container vertical-stack button-container">
                <div className="flex-container flex-vertical set-width">
                    <UIButton className="primary-button" text="Current Alerts" onClick={ onCurrentAlerts } />
                    <UIButton className="primary-button" text="Add Alert" onClick={ onAddAlert } />
                </div>

                <div className="flex-width" />
            </div>
        </div>
    );
}